import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ebay': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M405.2 263.8C376.1 264.7 358 270 358 289.1 358 301.5 367.9 314.9 393 314.9 426.7 314.9 444.6 296.5 444.6 266.5V263.2C432.8 263.2 418.3 263.3 405.2 263.8M476.7 303.5C476.7 312.8 477 322.1 477.7 330.3H447.9C447.1 323.4 446.8 316.7 446.8 310.1 430.7 329.9 411.5 335.6 384.9 335.6 345.4 335.6 324.3 314.7 324.3 290.6 324.3 255.6 353.1 243.3 402.9 242.2 416.6 241.9 431.9 241.8 444.6 241.8V238.4C444.6 215 429.6 205.4 403.6 205.4 384.3 205.4 370 213.4 368.6 227.2H334.9C338.5 192.8 374.6 184.1 406.4 184.1 444.5 184.1 476.7 197.6 476.7 237.9V303.5zM127.7 246.7C125.4 192 40.2 190.1 33.3 246.7H127.7zM32.7 268.1C36.2 326.4 111.9 325.5 123.9 289.7H157C150.6 324.1 114 335.8 82.6 335.8 25.4 335.8 0.1 304.3 0.1 261.8 0.1 215 26.3 184.2 83.1 184.2 128.4 184.2 161.5 207.9 161.5 259.6V268.1H32.7zM243.7 313.8C273.5 313.8 293.9 292.3 293.9 260 293.9 227.6 273.5 206.2 243.7 206.2 214.1 206.2 193.5 227.6 193.5 260 193.5 292.3 214.1 313.8 243.7 313.8M161.5 127.8H193.6V208.4C209.3 189.7 231 184.2 252.3 184.2 288 184.2 327.7 208.3 327.7 260.4 327.7 304 296.2 335.8 251.7 335.8 228.4 335.8 206.6 327.5 193 310.9 193 317.5 192.6 324.1 191.9 330.4H160.4C160.9 320.2 161.5 307.6 161.5 297.3V127.8zM640 189.5L540.8 384.3H504.9L533.4 330.2 458.8 189.5H496.3L551.2 299.4 606 189.5H640z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ebay.js
// module id = PqZ5
// module chunks = 144